<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>
<script>
export default {
  name: "App",
  data () {
    const self = this
    return {
      langDatas: sessionStorage.getItem('lang')
    }
  },
  created: function () { //钩子函数
    this.userData()
    this.langTypeData()
    this.config()
    this.localSocket()
    this.$nextTick(function () {
      setInterval(this.onTime, 10000)
    })
    // 动态引入不同的css文件
    require('../src/styles/reset.css')
  },
  methods: {
    langTypeData: function () {
      this.axios.get(this.api.ApiUrl.langtype).then((result) => {
        let langData = result.data
        if (langData.code == 20000) {
          this.GLOBAL.langTypeList = langData.data
          this.GLOBAL.lang = Number(sessionStorage.getItem('lang'))
          if (this.GLOBAL.lang == '' || this.GLOBAL.lang == null || this.GLOBAL.lang == undefined) {
            this.GLOBAL.lang = Number(this.GLOBAL.langTypeList[0].id)
          }
        }
        if (this.GLOBAL.lang == 1) {
          this.$i18n.locale = 'zh'
        } else if (this.GLOBAL.lang == 2) {
          this.$i18n.locale = 'en'
        } else {
          this.$i18n.locale = 'zh'
        }
        this.getLangList()
      }).catch(error => {
        console.log(error)
        this.errored = true
      })
    },
    getLangList: function () {
      this.axios.get(this.api.ApiUrl.lang + '?lang=' + this.GLOBAL.lang + '&type=1').then((result) => {
        let langData = result.data
        if (langData.code == 20000) {
          this.GLOBAL.langList = langData.data
          this.langList = this.GLOBAL.langList
        }
      }).catch(error => {
        console.log(error)
        this.errored = true
      })
    },
    config: function () {
      this.axios.get(this.api.ApiUrl.config).then((result) => {
        var configData = result.data
        if (configData.code == 20000) {
          this.GLOBAL.companyUrl = configData.data.url
          this.GLOBAL.logo = configData.data.logo
          this.GLOBAL.company = configData.data.company
          this.GLOBAL.companyEn = configData.data.companyEn
          this.GLOBAL.copyright = configData.data.copyright
          this.GLOBAL.contactTel = configData.data.contactTel
          this.GLOBAL.contactAddress = configData.data.contactAddress
          this.GLOBAL.contactEmail = configData.data.contactEmail
        }
      }).catch(error => {
        console.log(error)
        this.errored = true
      })
    },
    userData: function () {
      //this.GLOBAL.token = this.$cookies.get('token');
      this.GLOBAL.token = sessionStorage.getItem('token')
      this.GLOBAL.user = JSON.parse(sessionStorage.getItem('user'))
      this.GLOBAL.token_expires_in = JSON.parse(sessionStorage.getItem('token_expires_in'))

      //this.GLOBAL.user = this.$cookies.get('user');
      //this.GLOBAL.token_expires_in = this.$cookies.get('token_expires_in');
      if (this.$moment().unix() >= this.GLOBAL.token_expires_in) {
        this.$router.push({ path: '/login' })
      }
    },
    localSocket () {
      let that = this
      if ("WebSocket" in window) {
        console.log("您的浏览器支持 WebSocket!")
        that.ws = new WebSocket(`ws://tcp.tpaicloud.com:20966`)
        //that.ws = new WebSocket(`ws://14.116.147.6:20968`);
        that.GLOBAL.setWs(that.ws)
        that.ws.onopen = that.onopen()
        that.$store.commit('savePath', true)
        that.ws.onclose = function () {
          // 关闭 websocket
          console.log("连接已关闭...")
          that.$store.commit('savePath', false)
          setTimeout(() => {
            that.localSocket()
          }, 100)
        }
      } else {
        // 浏览器不支持 WebSocket
        console.log("您的浏览器不支持 WebSocket!")
      }
    },
    onopen () {
      console.log("连接已连接...")
      setTimeout(() => {
        if (this.GLOBAL.ws && this.GLOBAL.ws.readyState == 1 && this.GLOBAL.user) {
          this.GLOBAL.ws.send('{"Type":1100,"user_id":' + this.GLOBAL.user.id + ',"txnNo":' + Date.parse(new Date()) + '}')
        }
      }, 2000)
    },
    onTime () {
      let that = this
      console.log(that.GLOBAL.ws)
      if (that.GLOBAL.ws && that.GLOBAL.ws.readyState == 1) {
        that.GLOBAL.ws.send('{"Type":80,"txnNo":' + Date.parse(new Date()) + '}')
      }
    }
  }
}
</script>

<style>
body {
  margin: 0px;
  padding: 0px;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, SimSun, sans-serif;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
}

#app {
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;
}

.el-table .cell {
  overflow: unset !important;
}

#translate {
  position: absolute;
  z-index: 9999;
}

.el-input-group__append,
.el-input-group__prepend,
.el-input__inner {
  padding: 0 12px;
}

.el-card {
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/App.vue